module.exports = __webpack_public_path__ + "static/media/detail-trash.1bd2a47f.svg";